import { render, staticRenderFns } from "./prdProducaoItemModal.vue?vue&type=template&id=2116e49e&scoped=true&"
import script from "./prdProducaoItemModal.vue?vue&type=script&lang=js&"
export * from "./prdProducaoItemModal.vue?vue&type=script&lang=js&"
import style0 from "./prdProducaoItemModal.vue?vue&type=style&index=0&id=2116e49e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116e49e",
  null
  
)

export default component.exports